var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDenemeKulubu = function SvgDenemeKulubu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.905 106.58L97.0566 260.495C78.8895 276.246 51.3989 274.301 35.6484 256.133C20.3177 238.455 21.6974 211.821 38.7762 195.831L209.633 41.8987",
    fill: "url(#paint0_linear_4330_4024)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.605 66.8842L199 178.653C198.888 199.382 215.602 216.277 236.331 216.39L236.339 216.39C257.068 216.502 273.964 199.788 274.076 179.059L274.681 67.2904C274.793 46.5612 258.079 29.6661 237.35 29.5539L237.342 29.5539C216.613 29.4417 199.717 46.155 199.605 66.8842Z",
    fill: "url(#paint1_linear_4330_4024)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275 66.474C275.008 87.1776 258.238 103.974 237.526 103.982L127.032 104.042C106.329 104.051 89.5325 87.2805 89.5239 66.5682C89.5068 45.8646 106.286 29.0686 126.989 29.06L237.483 29C258.187 28.9914 274.983 45.7617 274.991 66.474H275Z",
    fill: "url(#paint2_linear_4330_4024)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.763 104.163C146.507 104.163 163.323 87.3475 163.323 66.6038C163.323 45.8602 146.507 29.0442 125.763 29.0442C105.02 29.0442 88.2036 45.8602 88.2036 66.6038C88.2036 87.3475 105.02 104.163 125.763 104.163Z",
    fill: "#2B81FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4330_4024",
    x1: 267.862,
    y1: 41.9092,
    x2: 39.0475,
    y2: 284.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4330_4024",
    x1: 199.812,
    y1: 29.3833,
    x2: 328.782,
    y2: 82.0188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4330_4024",
    x1: 274.968,
    y1: 29.0034,
    x2: 222.797,
    y2: 157.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })))));
};
export default SvgDenemeKulubu;